'use strict';

var chunkUGOVSGEW_js = require('./chunk-UGOVSGEW.js');
var chunkLGEI4JLR_js = require('./chunk-LGEI4JLR.js');
var chunk5RKAFQX4_js = require('./chunk-5RKAFQX4.js');
var chunkERLKLNQZ_js = require('./chunk-ERLKLNQZ.js');

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function f(t,p){let{deep:n}=chunkERLKLNQZ_js.c({deep:!0},p);if(t==null||chunkUGOVSGEW_js.a(t)||chunkLGEI4JLR_js.a(t))return t;if(Array.isArray(t))return t.map(e=>n&&chunk5RKAFQX4_js.a(e)?f(e,{deep:n}):e);if(t instanceof Set){let e=new Set;for(let r of t.values())n&&chunk5RKAFQX4_js.a(r)?e.add(f(r,{deep:n})):e.add(r);return e}else if(t instanceof Map){let e=new Map;for(let[r,i]of t.entries())n&&chunk5RKAFQX4_js.a(i)?e.set(r,f(i,{deep:n})):e.set(r,i);return e}else if(typeof t=="object"){let e={};return Object.entries(t).forEach(([r,i])=>{n&&chunk5RKAFQX4_js.a(i)?e[r]=f(i):e[r]=i;}),e}else return t}

exports.a = f;
